import { FlowDurationSchema } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const WaitForSignalBlockConfigSchema = z.object({
  signalName: z.string({ message: 'Choose external source for signaling.' }),
  timeout: FlowDurationSchema,
});
export type WaitForSignalBlockConfig = z.infer<typeof WaitForSignalBlockConfigSchema>;

export const WaitForSignalBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.WaitForSignal),
  config: WaitForSignalBlockConfigSchema,
});
export type WaitForSignalBlock = z.infer<typeof WaitForSignalBlockSchema>;
